"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.curriedEvalExpression = void 0;
var evaluation_context_1 = require("../evaluation-context");
var Either_1 = require("fp-ts/lib/Either");
var function_1 = require("fp-ts/lib/function");
var memoize_1 = __importDefault(require("lodash/memoize"));
var getCompiledExpression_1 = __importDefault(require("./getCompiledExpression"));
var preprocessExpression_1 = require("./preprocessExpression");
var lazyEval = function (sce) { return function (context, localVariablesAndMethods) {
    return (0, Either_1.tryCatch)(function () {
        var res = sce.eval((0, evaluation_context_1.createRootContext)(context), localVariablesAndMethods);
        return res;
    }, function (e) { return e; });
}; };
var evaluateCompiledExpression = function (e) { return e.map(function (sce) { return lazyEval(sce); }); };
var _curriedEvalExpression = (0, function_1.compose)(evaluateCompiledExpression, (0, memoize_1.default)(getCompiledExpression_1.default));
// If the expression can compile, returns a caching function to evaluate
var curriedEvalExpression = function (expression, options) {
    if (options === void 0) { options = {}; }
    return _curriedEvalExpression((0, preprocessExpression_1.processExpr)(options)(expression));
};
exports.curriedEvalExpression = curriedEvalExpression;
//# sourceMappingURL=getMemoizedEval.js.map